import React from 'react';
import { Link } from 'react-router-dom';
import './home.css'; // Import the CSS file for styling

function Home() {
  return (
    <div className="all">
    <div className="home-container">
       <div className="vertical-line"></div> {/* Vertical line */}
      <header className="header">
        <Link to="/" className="logo-link">
          <img
            src="/images/Traditional Line Logo - B&W white and black border.jpg"
            alt="Logo"
            className="logo"
          />
        </Link>
        <img
          src="/images/Architectural Restoration subscript transparent.png"
          alt="Subscript"
          className="subscript"
        />
      </header>
    
      <div className="main-content">
        <div className="house-linework-container">
          <img
            src="/images/house linework 4.png"
            alt="House Linework"
            className="house-linework"
          />
   
   <div className="address">
   <p>143 West 21st St<br />New York, NY 10011
            <br />(t) 212 627-3555
            <br /> Mon-Fri 8:30am-5:00pm
            <br /> restore@traditionalline.com
            </p>
        
            </div>
        </div>
       
        <nav className="nav-section">
          <ul>
            <li>
              <Link to="/general-contracting">
                <img
                  src="/images/TL Service Icons/100px/PSD/resized/general contracting.png"
                  alt="General Contracting"
                  className="nav-icon"
                />
                General Contracting
              </Link>
            </li>
            <li>
              <Link to="/wood-metal-finishing">
                <img
                  src="/images/TL Service Icons/100px/PSD/resized/wood finishing.png"
                  alt="Wood Finishing"
                  className="nav-icon"
                />
                Wood & Metal Finishing
              </Link>
            </li>
            <li>
              <Link to="/furniture-objects">
                <img
                  src="/images/TL Service Icons/100px/PSD/resized/furniture and objectts.png"
                  alt="Furniture & Objects"
                  className="nav-icon"
                />
                Furniture & Objects
              </Link>
            </li>
            <li>
              <Link to="/hardware-restoration">
                <img
                  src="/images/TL Service Icons/100px/PSD/resized/hardware restoration.png"
                  alt="Hardware Restoration"
                  className="nav-icon"
                />
                Hardware Restoration
              </Link>
            </li>
            <li>
              <Link to="/art-services">
                <img
                  src="/images/TL Service Icons/100px/PSD/resized/Art services.png"
                  alt="Art Services"
                  className="nav-icon"
                />
                Art Services
              </Link>
            </li>
            <li>
              <Link to="/historic-interiors">
                <img
                  src="/images/TL Service Icons/100px/PSD/resized/historic interiors.png"
                  alt="Historic Interiors"
                  className="nav-icon"
                />
                Historic Interiors
              </Link>
            </li>
            <li>
              <Link to="/service-maintenance">
                <img
                  src="/images/TL Service Icons/100px/PSD/resized/ongoing maintenance.png"
                  alt="Service & Maintenance"
                  className="nav-icon"
                />
                Service & Maintenance
              </Link>
            </li>
            <li>
              <Link to="/masonry-fireplaces">
                <img
                  src="/images/TL Service Icons/100px/PSD/resized/fireplace and masonry.png"
                  alt="Masonry & Fireplaces"
                  className="nav-icon"
                />
                Masonry & Fireplaces
              </Link>
            </li>
            {/* <li>
              <Link to="/about">
              <img
              src="/images/TL Service Icons/about.png"
              alt="About"
              className="nav-icon"
            />
              
                About
              </Link>
            </li> */}
            {/* <li>
              <Link to="/media">
              <img
              src="/images/TL Service Icons/media.png"
              alt="Media"
              className="nav-icon"
            />
                Media
              </Link>
            </li> */}
            <li>
              <Link to="/postcards">
              <img
              src="/images/TL Service Icons/postcards.png"
              alt="Postcards"
              className="nav-icon"
            />
                Postcards
              </Link>
            </li>
          </ul>
        </nav>
      </div>
    </div>
    </div>
  );
}

export default Home;
